import React from "react";
import { Typography, Row, Col, Button } from "antd";
import "./styles.css";

const { Text } = Typography;
function Label({ size, title, mandatory, ...props }) {

    return (
        // <Row>
        //     <Col span={size}>
        <Typography className="custom-label">
            {title}
            {mandatory ? <span className="mandatorColor">*</span> : ""}:
        </Typography>
        //     </Col>
        // </Row>
    )
}
function CustomBtn({ id, btnType, htmlType, onClick, size, loading, shape, children, isDisabled, ...props }) {
    return (
        <>
            {id == "delete" ?
                <Button type={btnType} htmlType={htmlType} size={size} loading={loading} id={id} className="custom-btn custom-delete-button" disabled={isDisabled} onClick={onClick} {...props}>{children}</Button>
                : ''
            }
            {id == "save" ?
                <Button type={btnType} htmlType={htmlType} size={size} loading={loading} id={id} className="custom-btn custom-save-button" disabled={isDisabled} onClick={onClick} {...props}>{children}</Button>
                : ''
            }
            {id == "reset" ?
                <Button type={btnType} htmlType={htmlType} size={size} loading={loading} id={id} className="custom-btn custom-reset-button" disabled={isDisabled} onClick={onClick} {...props}>{children}</Button>
                : ''
            }
            {id == "update" ?
                <Button type={btnType} htmlType={htmlType} shape={shape} size={size} loading={loading} id={id} className="custom-btn custom-update-button" disabled={isDisabled} onClick={onClick} {...props}>{children}</Button>
                : ''
            }
        </>
    )
}
// function CustomBtn({ id, btnType, htmlType, onClick, size, loading, shape, children, isDisabled, ...props }) {
//     return (
//         <>
//             {id == "save" ?
//                 <Button type={btnType} htmlType={htmlType} shape={shape} size={size} loading={loading} id={id} className="custom-button" disabled={isDisabled} onClick={onClick} {...props}>{children}</Button>
//                 : ''
//             }
//         </>
//     )
// }

export { Label, CustomBtn };